import { z } from 'zod'

export const GeoBlockingTemplateResponseParser = z.object({
  isWhiteList: z.boolean(),
  geoListField: z.string(),
  name: z.string(),
  id: z.number()
})

export const GeoBlockingTemplatesResponseParser = z.array(GeoBlockingTemplateResponseParser)

export const GeoBlockingTemplatesDataResponseParser = z.object({
  data: GeoBlockingTemplatesResponseParser
})

export type GeoBlockingTemplateJSON = z.infer<typeof GeoBlockingTemplateResponseParser>

export type GeoBlockingTemplatesJSON = z.infer<typeof GeoBlockingTemplatesResponseParser>

export type GeoBlockingTemplatesResponse = z.infer<typeof GeoBlockingTemplatesDataResponseParser>
